var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"problem-trust v-centerer",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{staticClass:"problem-trust__text"},[_vm._v(" "+_vm._s(`${_vm.trust.sToFixed(0)}%`)+" ")]),_c('div',{staticClass:"problem-trust__chart"},[_c('canvas',{ref:"canvas"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }